import { Link } from 'react-router-dom'
import { useTranslation } from '../i18n'
import type { DashboardSummary } from '../types'

interface SummaryCardsProps {
  data: DashboardSummary | null
  loading: boolean
}

const LOADING_PLACEHOLDER = '--'

export function SummaryCards({ data, loading }: SummaryCardsProps) {
  const { t } = useTranslation()

  const passRate = data?.latestBuild?.passRate ?? 0
  const failing = (data?.statusCounts.failed ?? 0) + (data?.statusCounts.error ?? 0)
  const skipped = data?.statusCounts.skipped ?? 0
  const unassigned = data?.unassignedTests ?? 0

  const show = (value: string) => (loading ? LOADING_PLACEHOLDER : value)
  const highlight = (className: string) => (loading ? '' : className)

  return (
    <div className="grid grid-cols-5" style={{ marginBottom: '1.5rem' }}>
      <div className="card stat-card" data-testid="stat-total-tests">
        <span className="stat-value">{show(String(data?.totalTests ?? 0))}</span>
        <span className="stat-label">{t('label.totalTests')}</span>
      </div>
      <div className="card stat-card" data-testid="stat-pass-rate">
        <span
          className={`stat-value ${highlight(passRate >= 80 ? 'stat-success' : 'stat-warning')}`}
        >
          {show(`${passRate.toFixed(1)}%`)}
        </span>
        <span className="stat-label">{t('label.passRate')}</span>
      </div>
      <Link to="/failing" className="card stat-card stat-card-link" data-testid="stat-failed">
        <span className={`stat-value ${highlight(failing > 0 ? 'stat-error' : '')}`}>
          {show(String(failing))}
        </span>
        <span className="stat-label">{t('label.failingTests')}</span>
      </Link>
      <div className="card stat-card" data-testid="stat-skipped">
        <span className={`stat-value ${highlight(skipped > 0 ? 'stat-warning' : '')}`}>
          {show(String(skipped))}
        </span>
        <span className="stat-label">{t('label.skippedTests')}</span>
      </div>
      <div className="card stat-card" data-testid="stat-unassigned">
        <span className={`stat-value ${highlight(unassigned > 0 ? 'stat-warning' : '')}`}>
          {show(String(unassigned))}
        </span>
        <span className="stat-label">{t('label.unassignedTests')}</span>
      </div>
    </div>
  )
}
